import { render, staticRenderFns } from "./FirstPayPlanWizard.vue?vue&type=template&id=1215be96&scoped=true"
import script from "./FirstPayPlanWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstPayPlanWizard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FirstPayPlanWizard.vue?vue&type=style&index=0&id=1215be96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215be96",
  null
  
)

export default component.exports